import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber')({
  beforeLoad: () => ({
    entityType: 'claim' as const,
  }),
})
